import { CARPOOL_APP_INDEX_KAROS, CARPOOL_APPS } from "@/constants/country"
import { CarpoolApp } from "@/models/core"

export const getCarpoolAppConf = (carpoolApp: CarpoolApp) => {
    return CARPOOL_APPS[carpoolApp] || CARPOOL_APPS[CARPOOL_APP_INDEX_KAROS]
}

export const getCarpoolAppLogo = (carpoolApp: CarpoolApp = CARPOOL_APP_INDEX_KAROS) => {
    const appName = getCarpoolAppConf(carpoolApp).name
    return `/assets/${appName}/teamspace_logo.svg`
}
